import type React from "react";
import { ButtonsList } from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/ButtonsList";
import dayjs from "dayjs";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { getDefaultParamsForState } from "app/pages/digital-suite/home-page/helpers";
import { i18nFilter } from "app/filters/i18nFilter";
import { Step } from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/Step";
import type { IStepMetadata } from "app/pages/digital-suite/home-page/components/ActivationWizard/ActivationWizardUtils";
import { createExampleKeywordsList } from "app/pages/digital-suite/home-page/components/ActivationWizard/ActivationWizardUtils";
import { useKeywordGroups } from "app/services/keyword-groups";

export const MonitorKeywordListStep: React.FC<IStepMetadata> = (props) => {
    const i18n = i18nFilter();
    const userGroups = useKeywordGroups();

    const monitorKeywordList = async () => {
        props.onStepComplete("growth.homepage.wizard.button.monitorKeywordList");

        const goToKeywordsList = (keywordsListId: string): void => {
            proNavigator.go("digitalsuite_monitorkeywords", {
                ...getDefaultParamsForState("digitalsuite_monitorkeywords"),
                keywordGroupId: keywordsListId,
                keyword: `*${keywordsListId}`,
            });
        };

        userGroups.data.sort((a, b) => {
            const aDate = dayjs(a.AddedTime);
            const bDate = dayjs(b.AddedTime);
            return aDate.isAfter(bDate) ? -1 : 1;
        });

        if (userGroups.data.length) {
            goToKeywordsList(userGroups.data[0].Id);
        } else {
            createExampleKeywordsList().then((keywordsListId) => {
                goToKeywordsList(keywordsListId);
            });
        }
    };

    return (
        <Step
            {...props}
            title={i18n("growth.homepage.activationWizard.step.monitor_keyword_list.title")}
            description={i18n("growth.homepage.activationWizard.step.monitor_keyword_list.description")}
            buttonsList={
                <ButtonsList
                    buttons={[
                        {
                            text: i18n("growth.homepage.activationWizard.step.monitor_keyword_list.button"),
                            onClick: monitorKeywordList,
                            type: "primary",
                        },
                    ]}
                />
            }
        />
    );
};
